import { toast } from "sonner";

declare global {
    interface Window {
        html2canvas: any;
        jspdf: any;
    }
}

export const downloadAsPDF = async (elementId: string, fileName: string) => {
    try {
        // Show loading toast if you want, or just wait
        toast.info("Generating PDF...");

        const element = document.getElementById(elementId);
        if (!element) {
            toast.error("Content not found");
            return;
        }

        if (!window.html2canvas || !window.jspdf) {
            toast.error("PDF tools are initializing. Please try again in a moment.");
            return;
        }

        // Force strict dimensions for the capture to ensure high quality A4 match
        // A4 width ~ 210mm. At 96 DPI -> 794px. At 300 DPI -> 2480px.
        // We'll capture at a high scale
        const canvas = await window.html2canvas(element, {
            scale: 3, // High quality
            useCORS: true,
            logging: false,
            allowTaint: true,
            backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.98); // JPEG is faster/smaller than PNG for full page photos

        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Scale image to fit the A4 PDF perfectly
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

        // Save
        pdf.save(`${fileName}.pdf`);
        toast.dismiss();
        toast.success("PDF Downloaded");

    } catch (error) {
        console.error("PDF generation failed:", error);
        toast.error("Failed to generate PDF. Check console.");
    }
};

export const downloadAsImage = async (elementId: string, fileName: string, format: 'png' | 'jpeg' = 'png') => {
    try {
        toast.info(`Generating ${format.toUpperCase()}...`);
        const element = document.getElementById(elementId);
        if (!element) {
            toast.error("Content not found");
            return;
        }

        if (!window.html2canvas) {
            toast.error("Image tools are initializing. Please try again in a moment.");
            return;
        }

        const canvas = await window.html2canvas(element, {
            scale: 3,
            useCORS: true,
            logging: false,
            allowTaint: true,
            backgroundColor: "#ffffff",
        });

        const mimeType = format === 'png' ? 'image/png' : 'image/jpeg';
        const link = document.createElement('a');
        link.download = `${fileName}.${format}`;
        link.href = canvas.toDataURL(mimeType, 0.98);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.dismiss();
        toast.success(`${format.toUpperCase()} Downloaded`);

    } catch (error) {
        console.error("Image generation failed:", error);
        toast.error("Failed to generate image.");
    }
};
